export class CustomerGlid {
  public glid: string;
  public name: string;

  static fromDto(data: any): CustomerGlid {
    const customerGlid = new CustomerGlid();

    if (!data) {
      return null;
    }

    customerGlid.glid = data.glid;
    customerGlid.name = data.name;

    return customerGlid;
  }
}
